var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import OpportunityService from "../../../Services/Opportunity.service";
import CopyOpportunityForm from "./CopyOpportunityForm";
import useUniqueId from "../../Hooks/useUniqueId";
import useService from "../../Hooks/useService";
import PersonTypeService from "../../../Services/PersonType.service";
import ShowMoreList, { StringShowMoreListRenderer, } from "../../UI/ShowMoreList/ShowMoreList";
import { MAX_OPPORTUNITIES_PREVIEWED_ON_MODAL } from "../../Container/Pipeline/PipelineDetailListMenu";
const CopyOpportunityModal = (_a) => {
    var _b;
    var { pipelineId, opportunities } = _a, modalProps = __rest(_a, ["pipelineId", "opportunities"]);
    const opportunityIds = opportunities.map((o) => o.id);
    const makeId = useUniqueId()[1];
    const [personTypeIds, loadPersonTypeIds, loadPersonTypeIdsActions] = useService(PersonTypeService.getPersonTypesForPerson);
    React.useEffect(() => {
        if (opportunities && opportunities.length <= 1) {
            loadPersonTypeIds(opportunities[0].subject.affiliationId);
        }
        else {
            loadPersonTypeIdsActions.clear();
        }
    }, [
        loadPersonTypeIds,
        loadPersonTypeIdsActions,
        opportunities,
        opportunityIds.length,
    ]);
    return (_jsxs(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "Copy Opportunity", handleSubmit: (state) => {
            var _a, _b, _c;
            return OpportunityService.bulkCopy(Object.assign({ opportunityIds, assigneeId: (_a = state.assignee) === null || _a === void 0 ? void 0 : _a.personId }, (((_b = state.stage) === null || _b === void 0 ? void 0 : _b.id)
                ? { stageId: (_c = state.stage) === null || _c === void 0 ? void 0 : _c.id }
                : { pipelineId: state.pipeline.id })));
        }, children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("opportunities"), children: opportunities.length > 1
                            ? "Opportunities (" + opportunities.length + ")"
                            : "Opportunity" }), _jsx("div", { id: makeId("opportunities"), children: _jsx(ShowMoreList, { numOfItemsToPreview: MAX_OPPORTUNITIES_PREVIEWED_ON_MODAL, renderer: StringShowMoreListRenderer, items: opportunities.map((o) => o === null || o === void 0 ? void 0 : o.subject.fullName) }) })] }), _jsx(CopyOpportunityForm, { pipelineId: pipelineId, personTypeIds: (_b = personTypeIds === null || personTypeIds === void 0 ? void 0 : personTypeIds.data) === null || _b === void 0 ? void 0 : _b.map((pt) => pt.id) })] })));
};
export default CopyOpportunityModal;
